import {
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from "@material-ui/core";
import { closeModal } from "actions/modalActions";
import { useModalStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import { FC, useState } from "react";
import { fleetStatusConstants } from "constants/constants";
import { OnChangeEvent } from "types/general";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { updateMultipleFleetStatusAction } from "actions/daAndFleetActions";

interface DialogProps {}

export const FleetStatusChangeModalContent: FC<DialogProps> = () => {
  const classes = useModalStyles();
  const dispatch = useDispatch();
  const {
    fleetData: { fleetList, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);
  const [status, setStatus] = useState<number>(1);

  const onClose = () => dispatch(closeModal());

  const handleSubmit = () => {
    onClose();
    dispatch(updateMultipleFleetStatusAction(status, idListForUpdate));
  };

  return (
    <>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText className={classes.dialogText}>
          Status will be changed for the following fleets:
        </DialogContentText>
        <DialogContentText className={`${classes.dialogBoldText} ${classes.addScroll}`}>
          {idListForUpdate.map((id) => `${fleetList.find((fleet) => fleet.id === id)?.number}`).join(", ")}
        </DialogContentText>
        <FormControl style={{ marginTop: 24 }}>
          <Select
            variant="outlined"
            value={status}
            onChange={(e: OnChangeEvent) => setStatus(Number(e.target.value))}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  width: 240,
                },
              },
              variant: "menu",
              getContentAnchorEl: null,
              anchorOrigin: { vertical: "bottom", horizontal: "center" },
              transformOrigin: { vertical: "top", horizontal: "center" },
            }}
          >
            {fleetStatusConstants.map((status) => (
              <MenuItem key={status.value} value={status.value}>
                <ListItemText primary={status.option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <CustomButton buttonText={"Cancel"} onClick={onClose} variant="text" />
        <CustomButton buttonText={"Save"}  onClick={handleSubmit} variant="contained" />
      </DialogActions>
    </>
  );
};
